/*
 * Кнопка «Прогон мониторинга» в шапке. Своих цветов нет ни одного: белая заливка, обводка и
 * текст `--violet`, подложка наведения `--violet-bg`, точка сорвавшегося скана `--red`
 * (docs/ui-design.md §9 — ни одного фирменного цвета литералом).
 *
 * Селекторы составные (`:global(.btn).button`, 0,2,0): base.css подключается ПОСЛЕ модулей
 * (main.tsx импортирует App раньше стилей), и его `.btn` с `border: 1px solid transparent`
 * при равной специфичности перебил бы обводку — тот же приём, что `:global(.hdr).paused`.
 */

:global(.btn).button {
  flex: none;
  background: var(--white);
  border-color: var(--violet);
  color: var(--accent-ink);
}
:global(.btn).button:hover {
  background: var(--violet-bg);
}
:global(.btn).button:focus-visible {
  outline: 2px solid var(--violet-bg-2);
  outline-offset: 1px;
}

/*
 * Погашенная — у бренда нет мониторинга (docs/multi-brand.md §8). Цвета `btn-dis` (base.css),
 * рамка остаётся 1px, только цвета `--border`: ширина кнопки на каждой ступени лестницы та же.
 * Селектор на ступень выше обычного (0,3,0), чтобы перебить и цвет, и подложку наведения.
 */
:global(.btn).button.off,
:global(.btn).button.off:hover {
  background: var(--neutral-bg);
  border-color: var(--border);
  color: var(--muted);
  cursor: default;
}

.icon {
  position: relative;
  display: inline-flex;
  flex: none;
}

/*
 * Точка «идёт скан» — на самом значке, а не рядом: подпись на узком окне гаснет, и точка
 * обязана остаться там, где остаётся орган. Белое кольцо отделяет её от обводки радара.
 * Дыхание то же, что у точки хода прогона (`RunStatusBar.module.css`): медленное и неполное,
 * по §8 — избыточная анимация читается как «сделано ИИ».
 */
.dot {
  position: absolute;
  top: -3px;
  right: -4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--violet);
  box-shadow: 0 0 0 2px var(--white);
  animation: breathe 1.8s var(--ease) infinite;
}

/*
 * Точка «последний скан не удался» — на том же месте, что дышащая (они не бывают вместе:
 * смотрится только свежайший скан бренда). Не дышит: это не ход, а итог, который ждёт, пока
 * человек откроет диалог. `--red` — семантика статуса, а не декор (docs/ui-design.md §2).
 */
.fail {
  position: absolute;
  top: -3px;
  right: -4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--red);
  box-shadow: 0 0 0 2px var(--white);
}

@keyframes breathe {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (prefers-reduced-motion: reduce) {
  .dot {
    animation: none;
  }
}

/* Для чтения с экрана: состояние, которое глазу показывает точка. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── сжатие: лестница шапки (Shell.module.css), шаг 1439 ─────────────────────
 * Подпись «Прогон мониторинга» (186px) — самая широкая из гаснущих: с ней и с идущим прогоном
 * шапка требует 1423px, и на 1440 орган профиля оставался бы без запаса. Остаётся значок-радар
 * в той же обводке. Имя кнопки держат `aria-label` и `title` — из DOM ничего не удаляется
 * (docs/ui-design.md §4.1, правило 2). */
@media (max-width: 1439px) {
  .label {
    display: none;
  }
  :global(.btn).button {
    padding: 7px 9px;
  }
}

/* Телефон: пилюля становится кружком — на 390px каждый пиксель шапки отнят у ленты вкладок. */
@media (max-width: 640px) {
  :global(.btn).button {
    padding: 6px 7px;
  }
}
